import { Route, NavigationGuardNext } from "vue-router";

function hasQueryParams(route: Route): boolean {
  return !!Object.keys(route.query).length;
}

const persistQueryParams = (
  to: Route,
  from: Route,
  next: NavigationGuardNext<Vue>
) => {
  // 🚫 Skip if Vue Router is already redirecting (e.g., "/" → "/welcome")
  if ((to as any).redirectedFrom) {
    return next();
  }

  // ✅ Skip if target already has query parameters
  if (hasQueryParams(to)) {
    return next();
  }

  // ✅ Only copy query params if source has them and the route name is different
  if (hasQueryParams(from) && to.name && to.name !== from.name) {
    return next({ name: to.name, query: from.query, replace: true });
  }

  return next();
};

export default persistQueryParams;
